module.exports = __webpack_public_path__ + "media/components/resources/grid/prototype/thumb1-c0aebfd831a298c4d4137c42c427a6f0.jpg";